import {
    useAuth,
} from '../stores/auth-store';
import {
    isLoggedIn,
} from '../services/auth';

const excludedRoutes = ['login', 'logout', 'register'];
// Check if user is logged in via BE call, write result to the store
export async function isLoggedInUser({ to }) {
    // Avoid unnecessary requests for login routes
    if (excludedRoutes.includes(to.name)) return;

    const auth = useAuth();
    try {
        const response = await isLoggedIn();
        auth.setUser({
            uuid: response.data.uuid ?? null,
            email: response.data.email ?? null,
        });
    } catch (e) {
        auth.removeUser();
    }
}
